import {
  COMISSIONS_LIST,
  DELETE_COMMISSION,
  GET_PROMOCODE_BY_ID,
  GET_SUBADMIN_BY_ID,
  UPDATE_PROMOCODE,
  UPDATE_SYSTEM_ACCESS_STATUS,
} from "./ApiCalls";

export default {
  BASE_URL: "https://tenee-api.suffescom.dev/api/v1",
  API_URL: "https://tenee-api.suffescom.dev/api/v1",

  // ADMIN
  REGISTER_URL: "/hotel-admin/register",
  LOGIN_ADMIN: "/hotel-admin/login",
  CONFIGS: "/hotel-admin/setting/config",
  HIDE_REVIEW:"/hotel-admin/dashboard/reviews/request-to-hide",
  LOGOUT_ADMIN: "/hotel-admin/logout ",
  FORGET_PASSWORD_ADMIN: "/hotel-admin/forgot-password",
  RESET_PASSWORD: "/hotel-admin/reset-password",
  CHANGE_PASSWORD: "/hotel-admin/dashboard/change-password",
  ADMIN_UPDATE: "admin/editAdmin",
  GET_PROFILE: "/hotel-admin/dashboard/profile",
  UPDATE_PROFILE: "/hotel-admin/dashboard/update-profile",
  GET_GUEST_REVIEWS:"/hotel-admin/dashboard/booking/booking-guest-reviews",
  GET_USER_PERMISSIONS: "/hotel-admin/dashboard/permissions",

  // UPLOAD FILE

  UPLOAD_FILE: "/hotel-admin/uploadFile",
  UPLOAD_MULTIPLE: "/adminSetting/uploadMultipleFile",
  UPLOAD_MULTIPLE_FILE: "/file/add-multiple",

  //DASHBOARD

  NOTIFICATION: "/hotel-admin/notification",
  READ_NOTIFICATION: "/hotel-admin/notification/read-notification",
  NOTIFICATION_COUNT: "/hotel-admin/notification/count",
  DASHBOARD_DATA: "/hotel-admin/dashboard/state",
  HOTEL_STATISTICS:"/hotel-admin/dashboard/booking/booking-statistic",
  BOOKING_HISTORY:"/hotel-admin/dashboard/booking/booking-history-fitler",
  PIE_CHART:"/hotel-admin/dashboard/booking/booking-slot-analytics",
  GET_HOTELS_LIST_FOR_FULL_PANEL_HANDLE: "/hotel-admin/dashboard/hotels/list",

  // help

  HELP_LIST: "admin/inquiry/list",
  DELETE_INQUIRY: "admin/inquiry/delete",
  // pricing delete api
  PRICING_DELETE: "/hotel-admin/dashboard/hotel/remove-room-pricing",

  //  Help and support
  HELPANDSUPORT: "/hotel-admin/dashboard/help-and-support/list",
  SELPANDSUPPORTDETAIL: "/hotel-admin/dashboard/help-and-support/detail/",
  // accounting
  ACCOUNTING_LIST: "/admin/getUserTransactionsWithFilter",

  // ADD USER
  ADD_USER: "/admin/adduser",
  USER_LIST: "/admin/getUsersWithFilter",
  GET_USER_BY_ID: "/admin/getUserById/",
  UPDATE_USER: "/admin/editUser",

  //update  user ========
  DELETE_USER: "/admin/removeuser",
  USER_STATUS_CHANGE: "/admin/blockUnblockCustomer",
  USER_IMPORT_BY_CSV: "/admin/importCustomer",
  IMPORT_HOTEL: "/hotel-admin/dashboard/hotel/import",
  ARTIST_IMPORT_BY_CSV: "/admin/importArtistViaCSV",
  EXPORT_USER_CSV: "/admin/export/user",
  // export
  EXPORT_BOOKING_CSV: "",
  EXPORT_ACCOUNTING_CSV: "",

  // service provider
  SERVICE_PROVIDERS_LIST: "/admin/vendors",
  SERVICE_PROVIDER_VIEW: "/admin/vendor/view/",
  ADD_SERVICE_PROVIDER: "/admin/addvendor",
  UPDATE_SERVICE_PROVIDER: "admin/updatevendor",

  DELETE_PROVIDER: "/admin/archivevendor",
  STATUS_CHANGE_SERVICE_PROVIDER: "/admin/vendors/updatestatus/all",
  SERVICE_PROVIDER_IMPORT_BY_CSV: "admin/importVendorViaCSV",

  EXPORT_SERVICE_PROVIDER_CSV: "/admin/hotelMangement/export/hotel-admin",

  HOTEL_ADMIN_BLOCK_UNBLOCK: "/admin/hotelMangement/hotel-admin/block-unblock",

  EXPORT_BOOKING_HISTORY_CSV: "/hotel-admin/dashboard/booking/booking/export",
  EXPORT_BOOKING_CANCELLATION_CSV: "/hotel-admin/dashboard/booking/cancellation/export",
  EXPORT_FINANCE_CSV: "/hotel-admin/dashboard/booking/payments/export",

  // earning report
  EXPORT_HOTEL_LIST: "/hotel-admin/dashboard/hotel/export",

  GET_EARNING_REPORT: "/admin/transaction",

  //Event List

  EVENT_LIST: "admin/event/list",

  GET_JOB_BY_ID: "admin/post/view/",
  UPDATE_JOB: "admin/post/edit",
  DELETE_JOB_POST: "admin/post/delete",

  // service category

  SERVICE_CATEGORY_LIST: "/admin/host/getWithFilter",
  ADD_SERVICE_CATEGORY: "/admin/host/add",
  UPDATE_SERVICE_CATEGORY: "/admin/host/update",
  DELETE_SERVICE_CATEGORY: "/admin/host/remove/",
  VIEW_SERVICE_CATEGORY: "/admin/host/getById/",
  //transactions
  FINANCE_OVERVIEW: "/hotel-admin/dashboard/finance/overview",
  TRANSACTION: "/hotel-admin/dashboard/booking/payments/payment-list",
  TRANSACTION_DETAIL: "/hotel-admin/dashboard/booking/payments/transaction/",
  // content page
  ADD_CONTENT: "/content/add",
  CONTENT_VIEW: "/admin/contents/edit/",
  CONTENT_UPDATE: "/admin/contents/update",
  CONTENT_STATUS_CHANGE: "/content/updatestatus/all",
  CONTENT_DELETE: "/content/remove",
  CONTENT_LIST: "/admin/contents",

  // subscription
  GET_SUBSCRIPTION: "/admin/plan",
  ADD_SUBSCRIPTION: "/admin/plan/add",
  VIEW_SUBSCRIPTION: "/admin/plan/view/",
  EDIT_SUBSCRIPTION: "/admin/plan/update/",
  DELETE_SUBSCRIPTION: "/admin/plan/remove/",
  GET_SUBSCRIPTION_SUBSCRIBER: "/admin/Subscriptions",

  // Hotel Admin
  HOTEL_ADMIN_LIST: "/admin/hotelMangement/hotel-owners",
  HOTEL_ADMIN_ADD: "/admin/hotelMangement/create-update-hotel-admin",
  HOTEL_ADMIN_UPDATE: "/admin/hotelMangement/create-update-hotel-admin",
  HOTEL_ADMIN_DELETE: "/admin/hotelMangement/delete-hotel-admin/",
  //Hotel URl
  HOTEL_LIST: "/hotel-admin/dashboard/hotel/list",
  HOTEL_CREATE: "/hotel-admin/dashboard/hotel/add-hotel",
  HOTEL_UPDATE: "/hotel-admin/dashboard/hotel/update-hotel",
  HOTEL_DELETE: "/hotel-admin/dashboard/hotel/delete/",
  HOTEL_DETAIL: "/hotel-admin/dashboard/hotel/hotel-detail/",
  // hotel  Status active inactive
  HOTEL_STATUS_CHANGE: "/hotel-admin/dashboard/hotel/change-status",
  CHANGE_AVAILABILITY_STATUS:
    "/hotel-admin/dashboard/hotel/change-availability-status",
  HOTEL_STORE_SETTING: "/hotel-admin/store-setting",

  // faw
  ADD_FAQ: "/admin/addFaq",
  FAQ_VIEW: "/admin/getFaqsById/",
  FAQ_UPDATE: "/admin/editFaq",
  FAQ_STATUS_CHANGE: "/faq/updatestatus/all",
  FAQ_DELETE: "/admin/deleteFaq",
  FAQ_LIST: "/admin/getAllFaqs",
  // VIEW_SERVICE_CATEGORY: "/category/view/",

  // Manage Promocode
  ADD_PROMOCODE: "/hotel-admin/dashboard/promocode/create",
  PROMOCODE_LIST: "/hotel-admin/dashboard/promocode/list",
  UPDATE_PROMOCODE: "/hotel-admin/dashboard/promocode/update",
  DELETE_PROMOCODE: "/hotel-admin/dashboard/promocode/delete/",
  GET_PROMOCODE_BY_ID: "/hotel-admin/dashboard/promocode/detail/",
  PROMOCODE_STATUS_CHANGE: "/promocode/updatestatus/all",
  GET_PROMOCODE_STATS: "/hotel-admin/dashboard/promocode/stats",

  // manage Essentail
  ESSENTAIL_LIST: "/admin/amenity/hotel/getWithFilters",
  ESSENTIAL_ADD: "/admin/amenity/hotel/create",
  ESSENTIAL_UPDATE: "/admin/amenity/hotel/update/",
  ESSENTIAL_DELETE: "/admin/amenity/hotel/delete/",
  ESSENTIAL_DETAIL: "/admin/amenity/hotel/detail/",

  // manage room essential
  ROOM_ESSENTIAL_LIST: "/admin/amenity/room/getWithFilters",
  ROOM_ESSENTIAL_ADD: "/admin/amenity/room/create",
  ROOM_ESSENTIAL_UPDATE: "/admin/amenity/room/update/",
  ROOM_ESSENTIAL_DELETE: "/admin/amenity/room/delete/",
  ROOM_ESSENTIAL_DETAIL: "/admin/amenity/room/detail/",

  // Review management
  REVIEW_STATS: "/hotel-admin/dashboard/reviews/overview",
  REVIEW_LIST: "/hotel-admin/dashboard/reviews/list",
  REVIEW_REPLY: "/hotel-admin/dashboard/reviews/reply",

  // manage Room type
  ROOM_TYPES: "/admin/amenity/room/room-type",
  ROOM_TYPES_ADD: "/hotel-admin/dashboard/hotel/add-hotel-roomType",
  ROOM_TYPES_UPDATE: "/hotel-admin/dashboard/hotel/update-hotel-roomType",
  ROOM_TYPES_LIST: "/hotel-admin/dashboard/hotel/hotel-roomType-list",
  ROOM_GET_API: "/hotel-admin/dashboard/hotel/view-hotel-roomType/",
  CREATE_ROOM_TYPE: "/admin/amenity/room/createUpdate-roomType",
  DETAILS_ROOM_TYPE: "/admin/amenity/room/get-single-roomType",
  ROMMTYPE_DELETE: "/admin/amenity/room/delete-room-type/",

  //------------------
  ADD_SUB_ADMIN: "/hotel-admin/subadmin/create",
  UPDATE_SUB_ADMIN: "/hotel-admin/subadmin/update",
  SUBADMINS_LIST: "/hotel-admin/subadmin/list",
  DELETE_SUBADMIN: "/hotel-admin/subadmin/delete/",
  GET_SUBADMIN_BY_ID: "hotel-admin/subadmin/",
  UPDATE_SYSTEM_ACCESS_STATUS: "/admin/subadmin/updatestatus/all",

  // Room list
  ROOM_LIST: "/hotel-admin/dashboard/hotel/room-list",
  ROOM_ADD: "/hotel-admin/dashboard/hotel/add-room",
  ROOM_AVAIL: "/hotel-admin/dashboard/booking/available-room",
  ROOM_UPDATE: "/hotel-admin/dashboard/hotel/update-room",
  ROOM_DELETE: "/hotel-admin/dashboard/hotel/remove-room/",

  ROOM_DETAIL: "/hotel-admin/dashboard/hotel/room-list",
  // room pricing
  ROOM_PRICING: "/hotel-admin/dashboard/hotel/add-room-pricing",
  ROOM_PRICING_LIST: "/hotel-admin/dashboard/hotel/room-price-list",
  ROOM_PRICING_DETAIL: "/hotel-admin/dashboard/hotel/price-by-id/",
  ROOM_PRICING_UPDATE: "/hotel-admin/dashboard/hotel/update-room-pricing",
  PRICING_STATUS_UPDATE: "hotel-admin/dashboard/hotel/change-price-status",

  //role

  GET_ROLES: "/hotel-admin/permission/list",
  ADD_ROLES: "/hotel-admin/permission/create",
  EDIT_ROLE: "/hotel-admin/permission/update",
  DELETE_ROLE: "/hotel-admin/permission/remove/",
  VIEW_ROLE: "/hotel-admin/permission/",
  UPDATE_ROLE_STATUS: "/admin/updateRolestatus",

  // Order managementbooking/getWithFilters
  GET_BOOKING: "/hotel-admin/dashboard/booking/booking-history",
  CANCEL_BOOKING: "/hotel-admin/dashboard/booking/cancellation-list",
  CANCEL_BOOKING_DETAILS: "/hotel-admin/dashboard/booking/cancelled-booking/",
  UPCOMMING_URL: "/hotel-admin/dashboard/booking/upcoming-bookings",
  UPCOMMING_URL_DETAIL: "/hotel-admin/dashboard/booking/upcoming-bookings/",
  VIEW_BOOKING: "/hotel-admin/dashboard/booking/booking-detail/",
  UPDATE_BOOKING: "/hotel-admin/dashboard/booking/update-booking",
  GET_BOOKING_STATS: "/hotel-admin/dashboard/booking/booking-statistic",

  //  Manage Commissions
  COMMISSIONS_LIST: "/category/viewallcategory",
  DELETE_COMMISSION: "/category/remove",
  SET_COMMISSION: "category/update",
  UPDATE_DISPUTE: "/hotel-admin/dashboard/help-and-support/change-status",
  SEND_REPLY: "/hotel-admin/dashboard/help-and-support/reply",

  // set pin api url
  SET_PIN_URL: "/admin/hotelMangement/set-pin",
  PIN_LIST: "/admin/static/store",

  ADD_PROMOTION: "/admin/promotion/add",
  PROMOTION_LIST: "/admin/promotion/getWithFilter",
  UPDATE_PROMOTION: "/admin/promotion/update/",
  DELETE_PROMOTION: "/admin/promotion/remove/",
  GET_PROMOTION_BY_ID: "/admin/promotion/getById/",

  CONFIG_DATA: "/admin/configs/",
  BASIC_SETTING: "/adminSetting/getBasicSettingInfo",
  UPDATE_BASIC_SETTING: "/adminSetting/update-basicsetting",
  ADD_HOTEL_ADMIN: "/admin/hotelMangement/create-hotel-admin",

  // Notifications
  GET_NOTIFICATION_LIST: "/hotel-admin/dashboard/notifications/list",
  MARK_ALL_NOTIFICATIONS_AS_READ: "/hotel-admin/dashboard/notifications/mark-all-read",
  SINGLE_NOTIFICATION_MARK_AS_READ: (id) => `/hotel-admin/dashboard/notifications/${id}/mark-read`,

  // Reports 
  CUSTOMER_REPORTS: "/hotel-admin/dashboard/reports/analytics",
  REVENUE_REPORTS: "/hotel-admin/dashboard/reports/revenue-trends",
  GET_CUSTOMER_SEGMENTATION_DATA: "/hotel-admin/dashboard/reports/customer-segmentation",
  GET_AGE_DISTRIBUTION_CHART_DATA: "/hotel-admin/dashboard/reports/age-gender-distribution",
  GET_DURATION_TYPE_DISTRIBUTION_CHART_DATA: "/hotel-admin/dashboard/reports/duration-type-distribution",
  GET_REVENUE_BY_ROOM_TYPE_CHART_DATA: "/hotel-admin/dashboard/reports/revenue-by-room-type"
};
